import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-21355969"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "cms-flex--between mg-b--15"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "tag_container"
};
const _hoisted_5 = {
  class: "right_btn"
};
const _hoisted_6 = {
  style: {
    "margin-right": "5px"
  }
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "margin": "0 12px"
  }
};
const _hoisted_9 = {
  class: "cms-card-block",
  style: {
    "min-height": "250px"
  }
};
const _hoisted_10 = ["data-tag-index", "data-season-index"];
const _hoisted_11 = {
  class: "tvList_header"
};
const _hoisted_12 = {
  class: "header_left"
};
const _hoisted_13 = {
  class: "season_text"
};
const _hoisted_14 = ["onClick", "src"];
const _hoisted_15 = {
  class: "header_right"
};
import dayjs from 'dayjs';
import ManuallyUpload from '@/components/Upload/ManuallyUpload.vue';
import SubtitleDialog from '../components/SubtitleDialog/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import TagType from '../components/TagType/index.vue';
import { useI18n } from 'vue-i18n';
import { useVodLanguages } from '@/utils/cacheData';
import { getArrByReduce, downloadFile, downBase64File } from '@/utils/tools';
import { provide, nextTick } from 'vue';
import { elMessage, isEmptyArray } from '@/utils';
import { ElMessageBox } from 'element-plus';
import { importSeriesEpisodeApi, getDramaInfoApi, addTvSeasonMediaApi } from '@/api/vodNew';
import DramaInfo from '../DramaInfo/index.vue';
import { RecycleScroller } from 'vue-virtual-scroller';
import EpisodeItem from './EpisodeItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    /**
     * 重要提示!!!
     * uniqueId是很关键的属性，如果调试工具报找不到uniqueId一定要修复，
     * 否则会影响虚拟列表渲染（包括增删改查）。
     * buffer： 提前缓冲组件的高度，防止下拉变白
     * size-field： 当不存在item-size属性的时候，开启Variable size mode模式，通过数据上的size指定对应元素大小，达到动态高度的目的
     */

    const languageValRef = ref();
    const dramaValRef = ref();
    const subtitleDialogRef = ref();
    const FormRef = ref(); // 初始状态

    const initialFormData = ref(null);
    const isChange = ref(false);
    const dramaInfoObj = ref({
      visible: false,
      data: null
    }); // 是否有一个未展开，false: 需要折叠 || true :需要展开

    const oneTableDontShow = computed(() => {
      let dontShow = Tags.value[dramaData.currentActive].tvSeasonList.some(item => !item.isShowTable);
      return dontShow;
    }); // 校验剧集名

    const validatorDrama = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入剧集数量')));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else if (value > 100) {
        callback(new Error(t('剧集数量不能超过100')));
      } else {
        callback();
      }
    }; // 校验排序


    const validatorSort = (rule, value, callback) => {
      if (value !== 0 && !value) {
        callback(new Error(t('请输入序号')));
      } else if (!/^[1-9]\d*$/.test(value)) {
        callback(new Error(t('请输入大于0的整数')));
      } else {
        callback();
      }
    };

    const checkedList = ref([]); // 季的删除按钮响应事件

    const openDeleteDialog = seasonIndex => {
      // if(Tags.value[dramaData.currentActive].tvSeasonList.length===1 ) {
      //     return elMessage('warning', '至少保留一季')
      // }
      // 接口返回的数据
      let isRemoteData = false;
      let msgArr = []; // 判断剧集是否上线

      Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList.forEach(item => {
        if (item.releaseStatus === 'online') {
          isRemoteData = true;
          msgArr.push(item.name);
        }
      });

      if (isRemoteData) {
        return ElMessageBox.confirm(t('剧集名已上线:', {
          list: msgArr.join(',')
        }), t('Warning'), {
          confirmButtonText: t('确定'),
          cancelButtonText: t('取消'),
          type: 'warning'
        });
      }

      deleteDialogConfig.visible = true;
      deleteDialogConfig.type = 'season';
      deleteDialogConfig.seasonIndex = seasonIndex;
    }; // 单独删除某季的某个剧集


    const deleteMediaOnSeason = (tagIndex, seasonIndex) => {
      // 一季要保留一个剧集
      let currentMediaNum = Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList.length;
      if (currentMediaNum === 1) return elMessage('warning', '至少保留一个剧集');

      if (currentMediaNum > 1) {
        // 已上线的剧集不允许删除
        let tagItem = Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[tagIndex];

        if (tagItem.releaseStatus === 'online') {
          return ElMessageBox.confirm(t('剧集名已上线:', {
            list: tagItem.name
          }), t('Warning'), {
            confirmButtonText: t('确定'),
            cancelButtonText: t('取消'),
            type: 'warning'
          });
        }

        deleteDialogConfig.visible = true;
        deleteDialogConfig.type = 'media';
        deleteDialogConfig.mediaIndex = tagIndex;
        deleteDialogConfig.seasonIndex = seasonIndex;
      }
    }; // 删除按钮弹框


    const deleteDialogConfig = reactive({
      visible: false,
      action: 'delete',
      type: 'season',
      seasonIndex: undefined,
      mediaIndex: undefined,
      config: {
        title: '提示'
      },
      confirm: done => {
        switch (deleteDialogConfig.type) {
          case 'season':
            Tags.value[dramaData.currentActive].tvSeasonList.splice(deleteDialogConfig.seasonIndex, 1);
            break;

          case 'media':
            console.log('删之前', JSON.stringify(Tags.value));
            Tags.value[dramaData.currentActive].tvSeasonList[deleteDialogConfig.seasonIndex].tvEpisodesList.splice(deleteDialogConfig.mediaIndex, 1);
            console.log('删了之后的数据', Tags.value);
            break;
        } // 这一步是为了重新获取size，防止虚拟列表变形
        // 同步重建：splice 后立即 addUniqueIds，保证 Tags.value 引用一致，
        // 避免 RecycleScroller 因 items 引用未变（浅 watch 不触发）导致 slot index 错位


        Tags.value = addUniqueIds(Tags.value); // console.log('Tags.value', Tags.value)

        dramaData.showLoading = false;
        deleteDialogConfig.visible = false;
        setTimeout(() => {
          done();
        }, 500);
      }
    });

    const onChange = (arr, code, newIndex) => {
      const oldIndex = arr.findIndex(item => item.audioLanguage === code.audioLanguage); // 1. move to right side:

      if (newIndex - 1 > oldIndex) {
        // console.log('right');
        let tempArr = [...arr.slice(0, oldIndex), ...arr.slice(oldIndex + 1, newIndex), code, ...arr.slice(newIndex)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      } // 2. move to left side: 
      else if (newIndex - 1 < oldIndex || newIndex - 1 === oldIndex) {
        // console.log('left');
        let tempArr = [...arr.slice(0, newIndex - 1), code, ...arr.slice(newIndex - 1, oldIndex), ...arr.slice(oldIndex + 1)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      } else if (newIndex === 1) {
        let cArr = JSON.parse(JSON.stringify(arr));
        cArr.splice(oldIndex, 1);
        let tempArr = [code, ...cArr];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        return newArr;
      }
    };

    const getCurrentActive = (arr, key, value) => {
      return arr.findIndex(item => item[key] === value);
    };

    const buttonOptions = reactive({
      visible: false,
      action: 'addDrama',
      config: {
        title: '',
        destroyOnClose: true
      },
      buttonsList: [{
        label: '导入',
        cellSlot: true,
        prop: '',
        uploadFile: file => {
          handleImportFile(file);
        }
      }, {
        label: '添加季',
        type: 'success',
        func: () => {
          let seasonLength = Tags.value[dramaData.currentActive].tvSeasonList.length;
          let newSeason = seasonLength + 1;
          Tags.value[dramaData.currentActive].tvSeasonList.push({
            tvEpisodesList: [{
              name: dramaData.name + `${seasonLength < 9 ? ' S0' + newSeason : ' S' + newSeason}E01`,
              sequence: 1,
              mediaContentList: [{
                videoCode: 'H264',
                videoResolution: '240P'
              }],
              subtitleList: [{
                language: '',
                filePath: ''
              }]
            }]
          }); // 新添加的季默认展开

          Tags.value[dramaData.currentActive].tvSeasonList[seasonLength].isShowTable = true;
        }
      }, {
        label: '保存',
        type: 'primary',
        func: () => {
          handleComplete();
        }
      }],
      confirm: done => {
        if (buttonOptions.action === 'addDrama') {
          addDramaInfo(done);
        } else if (buttonOptions.action === 'addLanguage') {
          // 添加Tags语言
          languageValRef.value.mForm.validate(valid => {
            if (valid) {
              dramaData.showLoading = true;
              let addItem = {
                audioLanguage: dramaData.formData.audioLanguage,
                sequence: Number(dramaData.formData.sequence),
                tagId: Date.now(),
                tvSeasonList: [{
                  isShowTable: true,
                  sequence: 1,
                  tvEpisodesList: [{
                    name: getMediaName(),
                    sequence: 1,
                    mediaContentList: [{
                      videoCode: 'H264',
                      videoResolution: '240P'
                    }],
                    subtitleList: [{
                      language: '',
                      filePath: ''
                    }]
                  }]
                }]
              };
              Tags.value.push(addItem); // console.log('旧的tags', Tags.value)

              Tags.value = onChange(Tags.value, addItem, addItem.sequence); // 刷新uniqueId，放在渲染出错

              Tags.value = addUniqueIds(Tags.value); //console.log('tags', Tags.value)

              dramaData.currentActive = getCurrentActive(Tags.value, 'audioLanguage', addItem.audioLanguage);
              setTimeout(() => {
                buttonOptions.visible = false;
                dramaData.showLoading = false; // 标记数据变更

                isChange.value = true;
                done();
              }, 200);
            } else {
              done();
            }
          });
        } else if (buttonOptions.action === 'edit') {
          languageValRef.value.mForm.validate(valid => {
            if (valid) {
              dramaData.showLoading = true;
              Tags.value[dramaData.currentActive].audioLanguage = dramaData.formData.audioLanguage;
              Tags.value[dramaData.currentActive].sequence = Number(dramaData.formData.sequence);
              Tags.value = onChange(Tags.value, Tags.value[dramaData.currentActive], Number(dramaData.formData.sequence));
              dramaData.currentActive = getCurrentActive(Tags.value, 'audioLanguage', dramaData.formData.audioLanguage);
              setTimeout(() => {
                buttonOptions.visible = false;
                dramaData.showLoading = false; // 标记数据变更

                isChange.value = true;
                done();
              }, 200);
            } else {
              done();
            }
          });
        } else if (buttonOptions.action === 'editLanguage') {
          // 编辑Tags语言
          languageValRef.value.mForm.validate(valid => {
            if (valid) {
              // 在Tags中找到tagId一样的项，然后变更语言
              Tags.value.forEach(item => {
                if (item.tagId === dramaData.formData.data.tagId) {
                  item.audioLanguage = dramaData.formData.audioLanguage;
                }
              });
              setTimeout(() => {
                buttonOptions.visible = false;
                dramaData.showLoading = false;
                dramaData.formData.data = null; // 标记数据变更

                isChange.value = true;
                done();
              }, 200);
            } else {
              done();
            }
          });
        }
      }
    }); // 导入续集  

    const handleImportFile = async file => {
      completeLoading.value = true;
      let params = new FormData();
      params.append('file', file.raw);
      params.append('id', props.detailInfo.id);
      params.append('cid', sessionStorage.getItem('currentCid'));
      params.append('cpspId', Number(sessionStorage.getItem('currentCpspid')));
      params.append('programType', props.detailInfo.programType);

      try {
        const res = await importSeriesEpisodeApi(params);

        if (res.code == '0') {
          setTimeout(() => {
            elMessage('success', '操作成功');
            getProgramInfoById();
          }, 200);
        } else {
          if (res.code == 'B0002') {
            downloadFile(res.data);
          } else if (res.code == 'B0003') {
            downloadFile(res.data);
          } else if (res.code == 'B0004') {
            downBase64File(res.data, `Series_${dayjs(new Date()).format('YYYY_MM_DD')}`);
          }
        }
      } catch (error) {
        console.log(error);
      }

      completeLoading.value = false;
    };

    const languageOptions = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      languageOptions.value = res;
    };

    provide('languageOptions', languageOptions);
    const selectOptions = computed(() => {
      const options = [];
      languageOptions.value.forEach(item => {
        options.push({ ...item,
          disabled: false
        });
      });
      return options;
    });

    const isChecked = index => {
      const idx = checkedList.value.indexOf(index);
      return idx === -1 ? false : true;
    };

    const handleCheckChange = index => {
      const idx = checkedList.value.indexOf(index);

      if (idx !== -1) {
        checkedList.value.splice(idx, 1);
      } else {
        checkedList.value.push(index);
      }
    }; // 已选的语言加上禁用


    const addDisabledForOptions = val => {
      if (!isEmptyArray(val)) {
        let ids = getArrByReduce(val, 'audioLanguage');
        selectOptions.value.forEach(item => {
          item.disabled = ids.includes(item['name']) ? true : false;
        });
      }
    };

    const dramaData = reactive({
      currentActive: 0,
      // 当前季
      currentSeasonIndex: 0,
      languageOptions: [],
      currentMediaItemIndex: 0,
      dramaVal: '',
      languageValue: '',
      addDramaLoading: false,
      seriesDetailList: [],
      name: '',
      showLoading: false,
      formList: [[{
        label: '语言',
        prop: 'audioLanguage',
        widgetType: 'Select',
        required: true,
        list: selectOptions,
        valueKey: 'name',
        filterable: true
      }], [{
        label: '排序',
        prop: 'sequence',
        widgetType: 'input',
        required: true,
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');

          if (buttonOptions.action === 'edit') {
            if (val > Tags.value.length) {
              dataForm.sequence = Tags.value.length;
            }
          } else if (buttonOptions.action === 'addLanguage') {
            if (val > Tags.value.length) {
              dataForm.sequence = Tags.value.length + 1;
            }
          }
        },
        controller: config => {
          // 编辑Tags语言时隐藏
          return buttonOptions.action !== 'editLanguage';
        }
      }]],
      formData: {
        audioLanguage: '',
        sequence: '',
        data: null
      },
      dramaFormList: [[{
        label: '剧集数',
        prop: 'dramaValue',
        widgetType: 'input',
        required: true,
        input: (val, data) => {
          data.dramaValue = data.dramaValue.replace(/[^\d]/g, '');
        }
      }]],
      dramaFormData: {
        dramaValue: ''
      },
      rules: {
        language: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        sequence: [{
          required: true,
          validator: validatorSort,
          trigger: 'change'
        }],
        dramaValue: [{
          required: true,
          validator: validatorDrama,
          trigger: 'blur'
        }],
        sourceId: [{
          required: true,
          message: t('请输入sourceId'),
          trigger: 'blur'
        }]
      }
    }); // 搜索框配置 JSON.parse(JSON.stringify(finishData.mediaContentList))

    const searchConfig = reactive({
      formData: [{
        name: dramaData.name,
        language: 'English',
        isShowTable: true,
        // sort: '',
        mediaContentList: [{
          videoCode: 'H264',
          videoResolution: '240P'
        }],
        subtitleList: [{
          language: '',
          filePath: ''
        }]
      }]
    });

    const getMediaName = () => {
      let length = searchConfig.formData.length;

      if (dramaData.name !== '') {
        if (length <= 9) {
          length = ' E0' + length;
        } else {
          length = ' E' + length;
        }

        return dramaData.name + length;
      }

      return '';
    }; // 排除 isShowTable 字段的工具函数


    const excludeIsShowTable = data => {
      if (!data) return data;

      const processObject = obj => {
        if (typeof obj !== 'object' || obj === null) return obj; // 处理普通对象

        const result = {};

        for (const key in obj) {
          if (key === 'isShowTable') continue; // 跳过 isShowTable 字段

          if (key === 'size') continue; // 跳过 size 字段

          if (key === 'uniqueId') continue; // 跳过 uniqueId 字段

          if (key === '__uid') continue; // 跳过 __uid 字段

          if (key === 'tagId') continue; // 跳过 tagId 字段

          if (key === 'tvSeasonList' && Array.isArray(obj[key])) {
            // 特殊处理 tvSeasonList 数组
            result[key] = obj[key].map(item => processObject(item));
          } else {
            result[key] = processObject(obj[key]);
          }
        }

        return result;
      };

      if (Array.isArray(data)) {
        return data.map(item => processObject(item));
      }

      return processObject(data);
    }; // 处理单集数据，给mediaContentList，subtitleList赋予默认值


    const processEpisode = episode => {
      // 处理 mediaContentList
      const mediaList = episode.mediaContentList?.length ? episode.mediaContentList.map(mediaItem => ({ ...mediaItem,
        isOnline: episode.releaseStatus === 'online'
      })) : [{
        videoCode: 'H264',
        videoResolution: '240P'
      }]; // 处理 subtitleList

      const subtitleList = episode.subtitleList?.length ? episode.subtitleList.map(subtitleItem => ({ ...subtitleItem,
        isOnline: episode.releaseStatus === 'online'
      })) : [{
        language: '',
        filePath: ''
      }];
      episode.mediaContentList = mediaList;
      episode.subtitleList = subtitleList;
    }; // 展开||关闭季


    const showSeasonTable = seasonItem => {
      seasonItem.isShowTable = !seasonItem.isShowTable;
    }; // 工具函数：分块处理数组


    const processInChunks = async (array, processItem, chunkSize = 10) => {
      for (let i = 0; i < array.length; i += chunkSize) {
        // chunk : []
        const chunk = array.slice(i, i + chunkSize);
        await new Promise(resolve => {
          // 用 requestIdleCallback 在浏览器空闲时处理, 避免阻塞关键渲染和用户交互
          requestIdleCallback(() => {
            // item: {} 每种语言的tag数据，执行这一步就是开始遍历每个语言下的数据
            chunk.forEach(item => processItem(item));
            resolve();
          });
        });
      }
    };
    /**
     * 为标签数据添加唯一标识符并处理媒体内容
     * @param {Array} tags - 原始标签数据
     * @returns {Array} 处理后的标签数据，包含唯一ID和格式化的媒体内容
     */
    // 剧集稳定唯一标识计数器：保证新建剧集（无后端 id）也能拿到一个删除/重排后不变的 uniqueId


    let episodeUidCounter = 0;

    const genEpisodeUid = () => `tmp-${Date.now()}-${++episodeUidCounter}`;

    const addUniqueIds = tags => {
      return tags.map((tag, tagIndex) => ({ ...tag,
        tagId: tagIndex,
        tvSeasonList: tag.tvSeasonList.map((season, seasonIndex) => ({ // 保留原始季节属性
          ...season,
          //处理媒体内容列表
          tvEpisodesList: season.tvEpisodesList.map((episode, episodeIndex) => {
            // 处理 mediaContentList
            const mediaList = episode.mediaContentList?.length ? episode.mediaContentList.map(mediaItem => ({ ...mediaItem,
              // 剧集的审核状态为online，并且mediaItem有id，则isOnline为true
              isOnline: episode.releaseStatus === 'online' && mediaItem.id
            })) : [{
              videoCode: 'H264',
              videoResolution: '240P'
            }]; // 处理 subtitleList

            const subtitleList = episode.subtitleList?.length ? episode.subtitleList.map(subtitleItem => ({ ...subtitleItem,
              // 剧集的审核状态为online，并且subtitleItem有id，则isOnline为true
              isOnline: episode.releaseStatus === 'online' && subtitleItem.id
            })) : [{
              language: '',
              filePath: ''
            }]; // 虚拟列表的剧集高度，超过三个url||字幕输入，高度260

            let itemSize = mediaList.length >= 3 || subtitleList.length >= 3 ? 260 : 155;
            return { ...episode,
              mediaContentList: mediaList,
              subtitleList: subtitleList,
              size: itemSize,
              // uniqueId 必须是「稳定且唯一」的，不能随数组增删重排而变化，
              // 否则 vue-virtual-scroller 的 key 追踪会失效，导致 slot 的 index 错位
              // （进而使 el-form-item 的 prop 索引越界，校验 value 取到 undefined）。
              // 策略：有后端 id 用 id；否则用 episode 上持久化的 __uid（首次生成后永不改变）。
              // 注意：不能复用旧的 uniqueId（新建剧集初始值可能是硬编码 '0-0-0' 会重复）。
              uniqueId: episode.id != null ? `ep-${episode.id}` : episode.__uid || (episode.__uid = genEpisodeUid())
            };
          })
        }))
      }));
    }; // 获取影片详情


    const getProgramInfoById = async () => {
      try {
        completeLoading.value = true;
        const params = {
          tvSeriesId: props.detailInfo.id
        };
        const {
          code,
          data
        } = await getDramaInfoApi(params);

        if (code !== 0) {
          completeLoading.value = false;
          return;
        } // 分块处理数据


        if (data?.length) {
          await processInChunks(data, langTag => {
            langTag.tvSeasonList?.forEach((season, seasonIndex) => {
              season.isShowTable = seasonIndex == 0; // 默认展开第一季
              // 处理单季中tvEpisodesList为[]的情况

              season.tvEpisodesList = season.tvEpisodesList.length ? season.tvEpisodesList : [{
                name: '',
                sequence: 1,
                mediaContentList: [],
                subtitleList: [],
                uniqueId: '0-0-0'
              }];
              season.tvEpisodesList?.forEach(episode => {
                // 处理单集数据
                processEpisode(episode);
              });
            });
          }); // 整合数据

          Tags.value = addUniqueIds(data);
          initialFormData.value = excludeIsShowTable(Tags.value);
        } else {
          Tags.value = addUniqueIds(initTagsData());
        }
      } catch (err) {
        console.error("Error:", err);
      } finally {
        completeLoading.value = false;
      }
    };

    const Tags = ref([{
      // 单独一种语言的剧集数据
      audioLanguage: 'English',
      sequence: '',
      // n个季的数据在这里面
      tvSeasonList: [{
        sequence: 1,
        isShowTable: true,
        // 某一个季的剧集数据 
        tvEpisodesList: [{
          name: getMediaName(),
          sequence: 1,
          mediaContentList: [{
            videoCode: 'H264',
            videoResolution: '240P'
          }],
          subtitleList: [{
            language: '',
            filePath: ''
          }],
          uniqueId: '0-0-0'
        }]
      }]
    }]); // 初始化Tags初始数据

    const initTagsData = () => {
      return [{
        audioLanguage: 'English',
        sequence: 1,
        tvSeasonList: [{
          sequence: 1,
          isShowTable: true,
          // 某一个季的剧集数据 
          tvEpisodesList: [{
            name: getMediaName(),
            sequence: 1,
            mediaContentList: [{
              videoCode: 'H264',
              videoResolution: '240P'
            }],
            subtitleList: [{
              language: '',
              filePath: ''
            }],
            uniqueId: '0-0-0'
          }]
        }]
      }];
    };

    const back = () => {
      // 未做任何修改直接返回
      if (!isChange.value) {
        emit('update-list');
        return emit('update:modelValue', false);
      }

      backDialogConfig.visible = true;
    }; // 返回按钮的弹框


    const backDialogConfig = reactive({
      visible: false,
      config: {
        title: '提示'
      },
      confirm: done => {
        emit('update:modelValue', false);
        emit('update-list');
        backDialogConfig.visible = false;
        setTimeout(() => {
          done();
        }, 500);
      }
    });

    const openAddDramaDialog = currentSeasonIndex => {
      buttonOptions.config.title = '添加剧集';
      dramaData.dramaFormData.dramaValue = '';
      dramaData.currentSeasonIndex = currentSeasonIndex;
      buttonOptions.action = 'addDrama';
      buttonOptions.visible = true;
    }; // 添加剧集


    const addDramaInfo = done => {
      dramaValRef.value.mForm.validate((valid, err) => {
        if (valid) {
          try {
            dramaData.addDramaLoading = true;

            for (let i = 0; i < Number(dramaData.dramaFormData.dramaValue); i++) {
              let length = Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList.length + 1;
              let seasonLength = dramaData.currentSeasonIndex + 1;
              let newMediaName = dramaData.name;
              length = length <= 9 ? 'E0' + length : 'E' + length;
              seasonLength = seasonLength <= 9 ? ' S0' + seasonLength : ' S' + seasonLength;
              Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList.push({
                name: newMediaName + seasonLength + length,
                sequence: Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList.length + 1,
                mediaContentList: [{
                  videoCode: 'H264',
                  videoResolution: '240P'
                }],
                subtitleList: [{
                  language: '',
                  filePath: ''
                }],
                uniqueId: `${dramaData.currentActive}-${dramaData.currentSeasonIndex}-${seasonLength}`
              });
            } // 添加剧集后刷新唯一ID


            Tags.value = addUniqueIds(Tags.value);
            dramaData.addDramaLoading = false;
            buttonOptions.visible = false;
            dramaData.dramaFormData.dramaValue = ''; // 标记数据变更

            isChange.value = true;
          } catch (error) {
            console.log('91111', error);
          }
        } else {
          console.log(err);
        }
      });
      done();
    }; // 往数组里添加字幕


    const addSubtitleItem = (selectData, subtitleList) => {
      let time = 0;
      console.log('selectData', selectData);
      console.log('subtitleList', subtitleList);
      selectData.forEach((item, index) => {
        if (time < selectData.length) {
          subtitleList.forEach((subItem, subIndex) => {
            if (!subItem.language && !subItem.filePath && time <= selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList[subIndex] = {
                  language: item.language,
                  filePath: item.filePath
                };
              }
            } else if (subIndex === subtitleList.length - 1 && time < selectData.length) {
              time++;

              if (subtitleList.findIndex(findItem => findItem.filePath === item.filePath) > -1) {
                return;
              } else {
                subtitleList.push({
                  language: item.language,
                  filePath: item.filePath
                });
              }
            }
          });
        }
      });
    };

    const dialogConfig = reactive({
      visible: false,
      action: 'add',
      config: {
        title: '添加字幕',
        destroyOnClose: true
      },
      confirm: () => {
        const {
          selectData
        } = subtitleDialogRef.value.selectTableConfig;
        let subtitleList = Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList[dramaData.currentMediaItemIndex].subtitleList;
        addSubtitleItem(selectData, subtitleList);
        subtitleDialogRef.value.multipleTable.commonTableRef.clearSelection();
        dialogConfig.visible = false;
      }
    }); // 搜索字幕

    const searchSubtitle = (index, seasonIndex) => {
      dramaData.currentMediaItemIndex = index;
      dramaData.currentSeasonIndex = seasonIndex;
      dialogConfig.visible = true;
    }; // 新增影片


    const addMedia = (index, seasonIndex) => {
      Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].mediaContentList.push({
        videoCode: 'H264',
        videoResolution: '240P'
      }); // 这一步是为了重新获取size，防止虚拟列表变形

      Tags.value = addUniqueIds(Tags.value);
    }; // 新增字幕


    const addSubtitle = (index, seasonIndex) => {
      Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].subtitleList.push({
        language: '',
        filePath: ''
      }); // 这一步是为了重新获取size，防止虚拟列表变形

      Tags.value = addUniqueIds(Tags.value);
    };

    const onTagClick = (item, index) => {
      dramaData.showLoading = true;
      dramaData.currentActive = index; // 没有季的数据

      if (!Tags.value[dramaData.currentActive].tvSeasonList || !Tags.value[dramaData.currentActive].tvSeasonList.length) {
        console.log('这个tag么有季的数据'); //默认给一个季

        Tags.value[dramaData.currentActive].tvSeasonList = [{
          sequence: 1,
          isShowTable: true,
          tvEpisodesList: [{
            name: '',
            sequence: 1,
            mediaContentList: [{
              videoCode: 'H264',
              videoResolution: '240P'
            }],
            subtitleList: [{
              language: '',
              filePath: ''
            }]
          }]
        }];
      }

      setTimeout(() => {
        dramaData.showLoading = false;
      }, 200);
    }; // 添加Tags语言


    const handleAddDrama = () => {
      buttonOptions.config.title = '添加';
      buttonOptions.action = 'addLanguage';
      buttonOptions.visible = true;
      dramaData.formData.audioLanguage = '';
      dramaData.formData.sequence = '';
    }; // 删除语言的弹框


    const deleteLangDialogConfig = reactive({
      visible: false,
      action: 'delete',
      //语言作为唯一标识
      lang: '',
      text: '是否删除该语言?',
      config: {
        title: '提示'
      },
      confirm: done => {
        Tags.value = Tags.value.filter(item => item.audioLanguage !== deleteLangDialogConfig.lang);
        dramaData.showLoading = false;
        deleteLangDialogConfig.visible = false;
        setTimeout(() => {
          done();
        }, 500);
      }
    }); // Tag的编辑/删除按钮事件

    const handleTagsCommend = row => {
      // console.log('row', row)
      if (row.type === 'edit') {
        buttonOptions.config.title = '编辑';
        buttonOptions.action = 'editLanguage';
        buttonOptions.visible = true;
        dramaData.formData.audioLanguage = row.data.audioLanguage;
        dramaData.formData.data = row.data;
      } else {
        // 删除
        if (Tags.value.length === 1) return elMessage('warning', t('至少保留一个语言'));
        if (row.data.tvSeasonList && row.data.tvSeasonList.length) return elMessage('warning', t('请先删除剧集内容再删除语言')); // 弹框确定删除，走deleteLangDialogConfig.confirm

        deleteLangDialogConfig.visible = true;
        deleteLangDialogConfig.lang = row.data.audioLanguage;
      }
    };

    const dramaConfig = reactive({
      formList: [{
        label: '剧集名称',
        prop: 'name',
        widgetType: 'input',
        placeholder: '请输入剧集名称',
        maxlength: 50,
        rules: [{
          required: true,
          message: '请输入剧集名称',
          trigger: 'blur'
        }]
      }, {
        label: '剧集编号',
        prop: 'sequence',
        widgetType: 'input',
        maxlength: 4,
        rules: [],
        input: (val, dataForm) => {
          dataForm.sequence = dataForm.sequence.replace(/[^\d]/g, '');
          let seasonIndex = Tags.value[dramaData.currentActive].tvSeasonList.findIndex(item => item.id == dataForm.tvSeasonId);
          Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList.forEach((item, index) => {
            FormRef.value[dramaData.currentActive]?.validateField(`tvSeasonList[${String(seasonIndex)}].tvEpisodesList[${String(index)}].sequence`);
          });
        }
      }]
    }); // 在渲染 HeaderSearch 时动态注入规则

    const getDynamicFormList = (tagIndex, seasonIndex, episodeIndex) => {
      // tagIndex 闭包保存
      return dramaConfig.formList.map(item => ({ ...item,
        rules: item.prop === 'sequence' ? [{
          validator: (rule, value, callback) => {
            // 直接使用闭包中的精确索引
            if (!value) {
              callback(new Error(t('请输入剧集编号')));
            }

            if (Tags.value[tagIndex].tvSeasonList[seasonIndex].tvEpisodesList.length > 1) {
              let num = 0;
              Tags.value[tagIndex].tvSeasonList[seasonIndex].tvEpisodesList.forEach(item => {
                if (item.sequence == value) {
                  num++;
                }
              });

              if (num > 1) {
                callback(new Error(t('剧集编号不能重复')));
              }
            }

            if (!/^[1-9]\d*$/.test(value)) {
              callback(new Error(t('请输入大于0的整数')));
            }

            callback();
          }
        }] : item.rules
      }));
    }; // 删除节目


    const deleteMediaItem = (index, mediaIndex, seasonIndex) => {
      if (mediaIndex === 0) {
        if (Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].mediaContentList.length === 1) {
          Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList.splice(index, 1);
        } else {
          Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].mediaContentList.splice(mediaIndex, 1);
        }

        dramaData.currentMediaItemIndex = dramaData.currentMediaItemIndex - 1;
      } else {
        Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].mediaContentList.splice(mediaIndex, 1);
      } // 这一步是为了重新获取size，防止虚拟列表变形


      Tags.value = addUniqueIds(Tags.value);
    };

    const handleSelectChange = val => {
      const filterItem = dramaData.languageOptions.filter(item => item.label === val)[0];
      filterItem.disabled = true;
    }; // 删除字幕


    const deleteSubtitleItem = (index, subtitleIndex, seasonIndex) => {
      Tags.value[dramaData.currentActive].tvSeasonList[seasonIndex].tvEpisodesList[index].subtitleList.splice(subtitleIndex, 1); // 这一步是为了重新获取size，防止虚拟列表变形

      Tags.value = addUniqueIds(Tags.value);
    };

    const scrollToError = (tagIndex, seasonIndex) => {
      // 获取错误季的 DOM 元素
      // data-tag-index data-season-index是元素上的自定义属性
      const seasonElement = document.querySelector(`[data-tag-index="${tagIndex}"][data-season-index="${seasonIndex}"]`);

      if (seasonElement) {
        // 滚动到该元素并添加高亮效果
        seasonElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        }); // 添加临时高亮效果（可选）

        seasonElement.classList.add('error-highlight');
        setTimeout(() => {
          seasonElement.classList.remove('error-highlight');
        }, 2000);
      }
    }; // 保存


    const handleComplete = async () => {
      // 只处理第一个发现的错误（避免多次跳转）
      let hasError = false;
      let firstError = null; // 记录第一个错误位置 { tagIndex, seasonIndex }
      // 第一步：收集所有表单的校验结果

      console.log('校验的数据', JSON.stringify(Tags.value));
      console.log('FormRef.value 数量', FormRef.value?.length, '| FormRef.value', FormRef.value);
      const validatePromises = FormRef.value.map((form, index) => new Promise(resolve => {
        // 诊断：打印每个 form 的 model 引用与 Tags.value[index] 是否一致
        console.log(`form[${index}] model === Tags.value[${index}]?`, form.model === Tags.value[index]);
        console.log(`form[${index}] model`, form.model);
        console.log(`form[${index}] fields 数量`, form.fields?.length);
        form.validate((valid, errObj) => {
          if (!valid) {
            console.log(`form[${index}] 校验失败 errObj`, errObj);
          }

          if (!valid && !hasError) {
            hasError = true; // 从错误信息中解析出季节索引

            const seasonIndexMatch = Object.keys(errObj)[0]?.match(/tvSeasonList\[(\d+)\]/);
            console.log('是哪一季出了问题', seasonIndexMatch);

            if (seasonIndexMatch) {
              const seasonIndex = parseInt(seasonIndexMatch[1]);
              firstError = {
                tagIndex: index,
                seasonIndex
              };
            }
          }

          resolve(valid);
        });
      }));
      await Promise.all(validatePromises);
      console.log('hasError', hasError);
      console.log('firstError', firstError); // 第二步：处理错误

      if (hasError && firstError) {
        const {
          tagIndex,
          seasonIndex
        } = firstError; // 1. 切换到错误所在的语言标签

        dramaData.currentActive = tagIndex;
        console.log('错误的地方', tagIndex); // 2. 展开包含错误的季

        Tags.value[tagIndex].tvSeasonList[seasonIndex].isShowTable = true; // 3. 等待视图更新

        await nextTick(); // 4. 滚动到错误位置

        scrollToError(tagIndex, seasonIndex);
      } else {
        // 第三步：没有错误时保存数据
        addSeriesEpisode();
      }
    };

    const completeLoading = ref(false);

    const addSeriesEpisode = async () => {
      try {
        completeLoading.value = true;
        let cloneData = JSON.parse(JSON.stringify(Tags.value));
        cloneData.forEach(tag => {
          // 清理 tag 层辅助字段
          delete tag.tagId;
          tag?.tvSeasonList.forEach((season, seasonIndex) => {
            delete season.isShowTable; // 季数
            // season.sequence = seasonIndex + 1

            season?.tvEpisodesList.forEach(episode => {
              // 清理 episode 层前端辅助字段（虚拟列表用，不应提交后端）
              delete episode.uniqueId;
              delete episode.size;
              delete episode.__uid;

              if (episode.poster) {
                // 截取信息弹框上传的图片base64地址
                episode.poster.base64Image = episode.poster.base64Image ? episode.poster.base64Image.split('base64,')[1] : '';
              }

              episode?.subtitleList.forEach((subtitle, index) => {
                if (!subtitle.language) {
                  episode.subtitleList.splice(index, 1);
                }
              });

              if (episode.mediaContentList.length) {
                episode.mediaContentList.forEach(mediaItem => {
                  // 去掉没用参数
                  delete mediaItem.isOnline;
                  delete mediaItem.language;
                });
              }
            });
          });
        });
        let postData = {
          cid: Number(sessionStorage.getItem('currentCid')),
          cpspId: Number(sessionStorage.getItem('currentCpspid')),
          tvSeriesId: props.detailInfo.id,
          tvSeriesContentList: cloneData
        };
        const res = await addTvSeasonMediaApi(postData);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          emit('update:modelValue', false);
          emit('update-list');
        }
      } catch (error) {
        console.log('877---', error);
      }

      completeLoading.value = false;
    }; // 打开信息弹框


    const openDramaInfo = (row, tagIndex, seasonIndex) => {
      console.log('row', row);
      dramaData.currentMediaItemIndex = tagIndex;
      dramaData.currentSeasonIndex = seasonIndex;
      dramaInfoObj.value.data = {
        detail: row.detail ? row.detail : {
          description: ''
        },
        poster: row.poster ? row.poster : {
          imageUrl: '',
          language: Tags.value[dramaData.currentActive].audioLanguage,
          programId: row.id,
          type: 'common'
        }
      };
      dramaInfoObj.value.visible = true;
    }; // 信息弹框确认事件


    const onDramaInfoChange = row => {
      // 修改detail详情和图片
      Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList[dramaData.currentMediaItemIndex].detail = row.detail;
      Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList[dramaData.currentMediaItemIndex].poster = row.poster;
    }; // 展开


    const showAllTable = () => {
      const shouldShow = oneTableDontShow.value; // true: 需要展开，false: 需要折叠

      Tags.value[dramaData.currentActive].tvSeasonList.forEach(item => {
        item.isShowTable = shouldShow;
      });
      nextTick(() => {
        Tags.value = [...Tags.value]; // 触发响应式更新
      });
    }; // 1. 深度监听（处理未知变更）


    watch(() => Tags.value, newVal => {
      if (!initialFormData.value) return;
      const isModified = !isEqual(excludeIsShowTable(newVal), excludeIsShowTable(initialFormData.value));
      isChange.value = isModified;
      console.log('isChange', isChange.value);
    }, {
      deep: true
    }); // 辅助函数：排除辅助字段

    const excludeMetaFields = data => {
      return JSON.parse(JSON.stringify(data, (key, val) => ['uniqueId', 'size', 'isShowTable', '__uid', 'tagId'].includes(key) ? undefined : val));
    }; // 辅助函数：深度比较（可使用lodash.isEqual）


    const isEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);

    watch(() => props.modelValue, val => {
      if (val) {
        completeLoading.value = true;
        getAllLanguages();
        getProgramInfoById();
      } else {
        isChange.value = false;
        Tags.value = initTagsData();
        dramaData.currentActive = 0;
        checkedList.value = [];
        initialFormData.value = null;
      }
    });
    watch(() => dramaData.currentActive, val => {
      checkedList.value = [];
    });
    watch(() => buttonOptions.visible, val => {
      if (val) {
        addDisabledForOptions(Tags.value);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _component_FormTable = _resolveComponent("FormTable");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [__props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", null, [_createElementVNode("header", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('剧集列表')), 1), _createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_4, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => Tags.value = $event),
        "buttons-list": buttonOptions.buttonsList,
        "current-active": dramaData.currentActive,
        onOnTagClick: onTagClick,
        onAddDrama: handleAddDrama,
        "language-options": languageOptions.value,
        onSelectChange: handleSelectChange,
        onHandleCommand: handleTagsCommend
      }, null, 8, ["modelValue", "buttons-list", "current-active", "language-options"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
        type: "text",
        onClick: showAllTable
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(oneTableDontShow) ? _ctx.$t('展开') : _unref(t)('折叠')), 1), _createElementVNode("img", {
          src: _unref(oneTableDontShow) ? require('@/assets/imgs/arrow_down.png') : require('@/assets/imgs/arrow_up.png'),
          alt: ""
        }, null, 8, _hoisted_7)]),
        _: 1
      }), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": buttonOptions.buttonsList
      }, {
        cellSlot: _withCtx(scope => [_createElementVNode("div", _hoisted_8, [_createVNode(ManuallyUpload, {
          limit: 1,
          cover: "",
          fileType: ['xlsx', 'xls'],
          accept: ".xlsx,.xls",
          "show-file-list": false,
          onHandleChange: scope.uploadFile
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary"
          }, {
            default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('导入续集')), 1)]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onHandleChange"])])]),
        _: 1
      }, 8, ["buttons-list"])])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Tags.value, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          key: index,
          model: item,
          ref_for: true,
          ref_key: "FormRef",
          ref: FormRef,
          class: "search-form"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tvSeasonList, (seasonItem, seasonIndex) => {
            return _openBlock(), _createElementBlock("div", {
              "data-tag-index": index,
              "data-season-index": seasonIndex,
              style: {
                "margin-bottom": "15px"
              },
              key: seasonIndex
            }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
              onClick: $event => showSeasonTable(seasonItem),
              class: "pointer mg-r--15",
              src: seasonItem.isShowTable ? require('@/assets/imgs/dropdown.png') : require('@/assets/imgs/dropup.png'),
              alt: ""
            }, null, 8, _hoisted_14), _createElementVNode("span", null, _toDisplayString(`Season ${seasonItem.sequence ? seasonItem.sequence : seasonIndex + 1}`), 1)])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
              type: "text",
              onClick: $event => openAddDramaDialog(seasonIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加剧集')), 1)]),
              _: 2
            }, 1032, ["onClick"]), _createVNode(_component_el_button, {
              type: "text",
              onClick: $event => openDeleteDialog(seasonIndex)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
              _: 2
            }, 1032, ["onClick"])])]), _withDirectives(_createElementVNode("div", null, [_createVNode(_unref(RecycleScroller), {
              class: "output-content-container",
              items: seasonItem.tvEpisodesList,
              buffer: 300,
              "size-field": "size",
              "key-field": "uniqueId"
            }, {
              default: _withCtx(({
                item: tagItem,
                index: tagIndex
              }) => [_createVNode(EpisodeItem, {
                "tag-item": tagItem,
                "tag-index": tagIndex,
                "season-index": seasonIndex,
                "language-index": index,
                "program-type": __props.detailInfo.programType,
                "get-dynamic-form-list": getDynamicFormList,
                onOpenDramaInfo: openDramaInfo,
                onSearchSubtitle: searchSubtitle,
                onAddSubtitle: addSubtitle,
                onAddMedia: addMedia,
                onDeleteMedia: deleteMediaOnSeason,
                onDeleteMediaItem: deleteMediaItem,
                onDeleteSubtitleItem: deleteSubtitleItem
              }, null, 8, ["tag-item", "tag-index", "season-index", "language-index", "program-type"])]),
              _: 2
            }, 1032, ["items"])], 512), [[_vShow, seasonItem.isShowTable]])], 8, _hoisted_10);
          }), 128))]),
          _: 2
        }, 1032, ["model"])), [[_vShow, index === dramaData.currentActive], [_directive_loading, dramaData.showLoading]]);
      }), 128))]), _createVNode(_component_MDialog, {
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createVNode(SubtitleDialog, {
          modelValue: dialogConfig.visible,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogConfig.visible = $event),
          ref_key: "subtitleDialogRef",
          ref: subtitleDialogRef,
          programType: __props.detailInfo.programType,
          languageOptions: languageOptions.value,
          formData: Tags.value[dramaData.currentActive].tvSeasonList[dramaData.currentSeasonIndex].tvEpisodesList[dramaData.currentMediaItemIndex],
          languageSelect: Tags.value[dramaData.currentActive].audioLanguage
        }, null, 8, ["modelValue", "programType", "languageOptions", "formData", "languageSelect"])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: buttonOptions.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => buttonOptions.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: buttonOptions.config,
        onOnConfirm: buttonOptions.confirm
      }, {
        default: _withCtx(() => [buttonOptions.action === 'addDrama' ? _withDirectives((_openBlock(), _createBlock(_component_FormTable, {
          key: 0,
          ref_key: "dramaValRef",
          ref: dramaValRef,
          "form-list": dramaData.dramaFormList,
          "form-data": dramaData.dramaFormData,
          rules: dramaData.rules,
          col: ['30%', '70%']
        }, null, 8, ["form-list", "form-data", "rules"])), [[_directive_loading, dramaData.addDramaLoading, void 0, {
          fullscreen: true
        }]]) : _createCommentVNode("", true), buttonOptions.action === 'edit' || buttonOptions.action === 'addLanguage' || buttonOptions.action === 'editLanguage' ? (_openBlock(), _createBlock(_component_FormTable, {
          key: 1,
          ref_key: "languageValRef",
          ref: languageValRef,
          "form-list": dramaData.formList,
          "form-data": dramaData.formData,
          rules: dramaData.rules,
          col: ['30%', '70%']
        }, null, 8, ["form-list", "form-data", "rules"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])])])), [[_directive_loading, completeLoading.value]])])) : _createCommentVNode("", true), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: deleteDialogConfig.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => deleteDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: deleteDialogConfig.config,
        onOnConfirm: deleteDialogConfig.confirm
      }, {
        default: _withCtx(() => [deleteDialogConfig.type === 'media' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确定要删除当前剧集的语言类型及该剧集语言类型下的全部内容？')), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认删除这一季吗?')), 1)], 64))]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: backDialogConfig.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => backDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: backDialogConfig.config,
        onOnConfirm: backDialogConfig.confirm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('修改还未保存，确定离开?')), 1)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: deleteLangDialogConfig.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => deleteLangDialogConfig.visible = $event),
        nativeConfig: {
          width: '600px',
          closeOnClickModal: false
        },
        dialogConfig: deleteLangDialogConfig.config,
        onOnConfirm: deleteLangDialogConfig.confirm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(deleteLangDialogConfig.text)), 1)]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"]), _createVNode(DramaInfo, {
        data: dramaInfoObj.value.data,
        modelValue: dramaInfoObj.value.visible,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => dramaInfoObj.value.visible = $event),
        onInfoChange: onDramaInfoChange
      }, null, 8, ["data", "modelValue"])], 64);
    };
  }

});